import {
  faArrowCircleDown,
  faArrowCircleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBell,
  faBorderAll,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardList,
  faComment,
  faCopy,
  faDownload,
  faEdit,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileArchive,
  faFileDownload,
  faFileExcel,
  faFileSignature,
  faFileWord,
  faFlag,
  faHistory,
  faInfoCircle,
  faListUl,
  faPlus,
  faSearch,
  faStream,
  faTimes,
  faTrashAlt,
  faUser,
  faFileAlt,
  faFile,
  faUserPlus,
  faCircle,
  faLink,
  faFileUpload,
  faUserCog,
  faQuestionCircle,
  faAngleLeft,
  faAngleRight,
  faPaperclip,
  faBan,
  faUsers,
  faTimesCircle,
  faCalculator,
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

const importIcons = () =>
  library.add(
    faArrowCircleDown,
    faArrowCircleUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faBell,
    faBorderAll,
    faChartLine,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faClipboardList,
    faComment,
    faCopy,
    faDownload,
    faEdit,
    faExchangeAlt,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faFileArchive,
    faFileDownload,
    faFileExcel,
    faFileSignature,
    faFileWord,
    faFlag,
    faHistory,
    faInfoCircle,
    faListUl,
    faPlus,
    faSearch,
    faStream,
    faTimes,
    faTrashAlt,
    faUser,
    faFileAlt,
    faFile,
    faUserPlus,
    faCircle,
    faLink,
    faFileUpload,
    faUserCog,
    faQuestionCircle,
    faAngleLeft,
    faAngleRight,
    faPaperclip,
    faBan,
    faUsers,
    faTimesCircle,
    faCalculator,
    faTimes
  );

export default importIcons;
